import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { PipesModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';
import { NgOtpInputModule } from  'ng-otp-input';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// dir === 'rtl' ?

@NgModule({
  declarations: [ PageNotFoundComponent ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    NgOtpInputModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,

    
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
    }
    }),
    MatDatepickerModule,
    MatInputModule
  ],
  exports: [
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,

    PipesModule,
    DirectivesModule,
    NgOtpInputModule,
    MatSnackBarModule,
    TranslateModule,
    MatDatepickerModule,
    MatInputModule,
    ],
})



export class SharedModule { }
